import Sales_QSet from "./roleQuestionSets/Sales";
import IT_QSet from "./roleQuestionSets/IT";
import Digimar_QSet from "./roleQuestionSets/Digimar";
import Commerce_QSet from "./roleQuestionSets/Commerce";
import None from "./roleQuestionSets/Digimar";

const QuestionSets = {
  "Select your functional area": None,
  "Head of Commerce": Commerce_QSet,
  "Director of IT": IT_QSet,
  "Director of Digital Marketing": Digimar_QSet,
  "Head of Sales": Sales_QSet,
};

export default QuestionSets;
